import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib1-shared-captcha-v2',
  templateUrl: './shared-captcha-v2.component.html',
  styleUrls: ['./shared-captcha-v2.component.scss'],
})
export class SharedCaptchaV2Component implements OnInit {
  
  @Output()
  recaptchaV2ResultEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  isValidWePassedRecaptcha: boolean;

  constructor() { }

  ngOnInit(): void { }
  
  resolved(captchaResponse: string): any {

    debugger;
    
    // We do NOT need to verify V2 token since we ONLY get a token if we passed the V2 puzzle
    this.isValidWePassedRecaptcha = true;

    this.recaptchaV2ResultEmitter.emit(true);   

  }
  
}
